import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';
import { METRES_TO_KMH } from '../utils/globals';

const WindSpeed = props => {
    const { language, windSpeedFormat, data } = props;

    return (
        <div className="wrapper-data-48h mc-widget-wind-speed">
            {/* Label */}
            <div className="wrapper-data-48h__labels mc-widget-wind-speed__labels">
                <div className="mc-widget-TemperaturePerceived__label">
                    <h3>
                        {translate(language, 'municipal48h_vel_vent')} ({
                            windSpeedFormat
                        })
                    </h3>
                </div>
            </div>
            {/* Data */}
            <div className="wrapper-data-48h__data mc-widget-wind-speed__data">
                {data.map((data, index) => (
                    <span key={index}>
                        {data.valor !== null
                            ? (
                                  Math.round(data.valor * METRES_TO_KMH * 10) /
                                  10
                              ).toFixed(0)
                            : ''}
                    </span>
                ))}
            </div>
        </div>
    );
};

WindSpeed.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.string,
            valor: PropTypes.number,
        })
    ),
    language: PropTypes.string,
    windSpeedFormat: PropTypes.string,
};

export default WindSpeed;



// WEBPACK FOOTER //
// ./src/partials/WindSpeed.js